import { isNotNullOrEmpty, isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";
import { getAbbreviationFullName, getAbbreviationShortName } from "../../FiasAbbriviations/FiasAbbreviations";

export function convertAbbreviationToFullName(name: string | undefined): string | undefined {
    const stringName = name?.toString();
    if (isNullOrEmpty(stringName)) {
        return undefined;
    }
    const fullAbbreviation = getAbbreviationFullName(stringName);
    if (isNotNullOrEmpty(stringName)) {
        return fullAbbreviation;
    }
    return undefined;
}

export function convertAbbreviationToShortName(name: string | undefined): string | undefined {
    const stringName = name?.toString();
    if (isNullOrEmpty(stringName)) {
        return undefined;
    }
    const fullAbbreviation = getAbbreviationShortName(stringName);
    if (isNotNullOrEmpty(stringName)) {
        return fullAbbreviation;
    }
    return undefined;
}
